/**
 * Route segment constants for embed URL building.
 * Mirrors `src/app/paths.ts` without Next.js imports.
 */
export const embedPaths = {
  srp(slugWithQuery: string) {
    return `/homes-for-sale/${slugWithQuery}`
  },
  ldp(address: string, bupi: string) {
    return `/home-details/${address}/${bupi}`
  },
  realEstateAgents() {
    return "/real-estate-agents"
  },
  realEstateAgentsByLocation(locationSlug: string) {
    return `/real-estate-agents/${locationSlug}`
  },
  realEstateAgent(locationSlug: string, agentSlug: string) {
    return `/real-estate-agents/${locationSlug}/${agentSlug}`
  },
  realEstateOffices() {
    return "/real-estate-offices"
  },
  realEstateOfficesByLocation(locationSlug: string) {
    return `/real-estate-offices/${locationSlug}`
  },
  realEstateOffice(locationSlug: string, officeSlug: string) {
    return `/real-estate-offices/${locationSlug}/${officeSlug}`
  },
  rentBase() {
    return "/homes-for-rent"
  },
} as const
